import Vue from 'vue'
import App from '@/app/app.vue'
import router from '@/router'
import store from '@/store'
import '@babel/polyfill'

import helpers from '@/plugins/helpers'
Vue.prototype.$helpers = helpers

// plugins
import vuetify from '@/plugins/vuetify'

import { dateFilter } from 'vue-date-fns'

Vue.filter('date', dateFilter)

import LayoutDefault from '@/layouts/default'

Vue.component('default-layout', LayoutDefault)

// Style
import '@/style/style.scss'

Vue.config.productionTip = false

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount('#app')
Vue.config.devtools = true
